import { Component } from '@angular/core';

@Component({
  selector: 'lib-shared-models',
  imports: [],
  templateUrl: './shared-models.html',
  styleUrl: './shared-models.css',
})
export class SharedModels {}
